var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"article-demand-list"},_vm._l((_vm.items),function(ad){return _c('div',{key:`articleDemand_${ad.articleNumber}`,staticClass:"mt-4 mr-4"},[_c('ArticleDemandListItem',{attrs:{"articleDemand":ad,"readonly":_vm.readonly}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }